import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ProductViewLayoutComponent } from '../../layout/product-view-layout.component';

@Component({
    selector: 'product-view-gift-boxing',
    templateUrl: './product-view-gift-boxing.html',
    standalone: true,
    imports: [DfImageDirective, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewGiftBoxingComponent {
    constructor(public productViewLayout: ProductViewLayoutComponent) {}

    get giftBoxing() {
        return this.productViewLayout.content.gift_boxing;
    }
    get content() {
        return this.productViewLayout.content;
    }
}
